import request from '@/common/request'
export default {

  //登录
  auth_login (self, data) {
    return request({
      url: '/auth/login',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },

  auth_logout (self, data) {
    return request({
      url: '/auth/logout',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },
  auth_validate (self, data) {
    return request({
      url: '/auth/validate',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },
  auth_smscode (self, data) {
    return request({
      url: '/auth/smscode',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },
  ///////
  //
  info_list (self, data) {
    return request({
      url: '/info/list',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },
  info_update (self, data) {
    return request({
      url: '/info/update',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },
  score_list (self, data) {
    return request({
      url: '/score/list',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  },
  user_list (self, data) {
    return request({
      url: '/user/list',
      data,
      options: {
        method: 'post',
        load: 0,
        json: 1
      }
    })
  }

 
}
